import { render, staticRenderFns } from "./drag-mask.vue.js?vue&type=template&id=3a87c2e0&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=template&id=3a87c2e0&scoped=true"
import script from "./drag-mask.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=script&lang=js"
export * from "./drag-mask.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=script&lang=js"
import style0 from "./drag-mask.vue.scss?vue&type=style&index=0&id=3a87c2e0&scoped=true&lang=scss!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=style&index=0&id=3a87c2e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87c2e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a87c2e0')) {
      api.createRecord('3a87c2e0', component.options)
    } else {
      api.reload('3a87c2e0', component.options)
    }
    module.hot.accept("./drag-mask.vue.js?vue&type=template&id=3a87c2e0&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=template&id=3a87c2e0&scoped=true", function () {
      api.rerender('3a87c2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIHelper/sceneAssistant/components/drag-mask.vue"
export default component.exports